import React, { ReactElement, useState } from 'react';
import rteUrl from 'consumer/signup/plans/rte-plan-widget.jpg';
import mixAndMatchUrl from 'consumer/signup/plans/mix-and-match-plan-widget.jpg';
import jumpstartUrl from 'consumer/signup/plans/jumpstart-plan-widget.jpg';
import mealKitUrl from 'consumer/signup/plans/meal-kit-plan-widget.jpg';
import { Component as SaleTagIcon } from 'icons/icon-ui--sale-tag.svg';
import Plan from 'models/Plan';
import { DiversifiedPlanGroup, PLAN_TYPE_TO_GROUP_NAME } from 'models/DiversifiedPlanGroup';
import AppliedCoupon from 'models/AppliedCoupon';
import { toCurrency } from 'utils/numbers';
import useAsyncEffect from '../../hooks/useAsyncEffect';
import { get } from '../../utils/network';
import IPlanInfo from '../../models/IPlanInfo';
import { ApiRoute } from '../../config';

interface Props {
  selectedPlan: Plan;
  discount: AppliedCoupon;
}

function PlanTypeHeader({
  selectedPlan,
  discount,
}: Props): ReactElement {
  const [isPlanInitialized, setIsPlanInitialized] = useState(Plan.isInitialized);
  const selectedPlanGroup = DiversifiedPlanGroup[PLAN_TYPE_TO_GROUP_NAME[selectedPlan.type]];
  const price = selectedPlanGroup.pricing?.[selectedPlan.name]?.[selectedPlan.extras].price ?? null;
  const imageMap = {
    DIVERSIFIED: { jpg: mixAndMatchUrl },
    MEAL_KIT: { jpg: mealKitUrl },
    PREPARED: { jpg: rteUrl },
    JUMPSTART: { jpg: jumpstartUrl },
  };

  const totalPrice = () => {
    const discountAmount = discount.calculateDiscount(selectedPlan);
    return price - discountAmount;
  };

  useAsyncEffect(async (isMounted) => {
    if (!Plan.isInitialized) {
      const response = await get<IPlanInfo[]>(ApiRoute.PLANS_SHORT);
      // @ts-expect-error TODO: fix null safety
      Plan.initialize(response.parsedBody);
      if (isMounted) setIsPlanInitialized(true);
    }
  }, []);

  return (
    <div className="c-widget-main-content">
      <div className="widget-image__sale_tag">
        <SaleTagIcon />
        SALE
      </div>
      <img src={imageMap[selectedPlanGroup.group].jpg} alt="widget icon" className="widget-image" />
      <div className="widget-info">
        <div className="plan-group-title">
          {selectedPlanGroup.title}
        </div>
        {(price) && (
          <div className="plan-group-price-container">
            {isPlanInitialized && toCurrency(totalPrice())}
            <div className="plan-original-price">
              {toCurrency(price)}
            </div>
            / week
          </div>
        )}
      </div>
    </div>
  );
}

export default PlanTypeHeader;
